import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./ds.module.css";

/** Page title bar: a purple accent bar, the title, inline chrome, then right-aligned actions. */
export function PageHeader({ title, actions, children }: { title: ReactNode; actions?: ReactNode; children?: ReactNode }) {
    return (
        <div className={styles.pageHeader}>
            <span className={styles.pageHeaderBar} />
            <h1 className={styles.pageHeaderTitle}>{title}</h1>
            {children}
            {actions && <div className={styles.pageHeaderActions}>{actions}</div>}
        </div>
    );
}

/** Every OP page carries this: the data is a frozen copy of the old platform's warehouse. */
export function ReadOnlyTag() {
    return (
        <span className={styles.readOnly}>
            <i className="bi bi-lock" aria-hidden="true" />
            <span>Read-Only, from Old Platforms Data Warehouse</span>
        </span>
    );
}

export function Breadcrumb({ items }: { items: { label: ReactNode; to?: string }[] }) {
    return (
        <nav className={styles.crumbs} aria-label="Breadcrumb">
            {items.map((item, i) => (
                <span key={i} style={{ display: "contents" }}>
                    {i > 0 && <span className={styles.crumbSep}>/</span>}
                    {item.to ? <Link to={item.to}>{item.label}</Link>
                        : i === items.length - 1 ? <span className={styles.crumbCurrent}>{item.label}</span>
                            : <span>{item.label}</span>}
                </span>
            ))}
        </nav>
    );
}

/** The uppercase label above a group of widgets. */
export function SectionLabel({ children }: { children: ReactNode }) {
    return <div className={styles.sectionLabel}>{children}</div>;
}
